/**
 * @generated SignedSource<<8c85c99134d82855799581ab5e1991ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SeriesDetailsDeleteMutation$variables = {
  id: string;
};
export type SeriesDetailsDeleteMutation$data = {
  readonly deleteSeries: {
    readonly id: string;
  };
};
export type SeriesDetailsDeleteMutation = {
  response: SeriesDetailsDeleteMutation$data;
  variables: SeriesDetailsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Series",
    "kind": "LinkedField",
    "name": "deleteSeries",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SeriesDetailsDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SeriesDetailsDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9aadb243a230897f6db5e6ce18fabe4f",
    "id": null,
    "metadata": {},
    "name": "SeriesDetailsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation SeriesDetailsDeleteMutation(\n  $id: ID!\n) {\n  deleteSeries(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ad86ebadd777b8cadc8e8d0362b8d57b";

export default node;
